import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { I18n } from 'components/translate';
import { UserPhoto } from 'components/user';
import { PropTypes } from 'prop-types';

import './UserInfo.scss';

class UserInfo extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string.isRequired,
    pictureThumbId: PropTypes.number,
    pictureFileKey: PropTypes.string,
    role: PropTypes.string
  };

  render() {
    const { className, email, name, pictureThumbId, pictureFileKey, role } =
      this.props;
    const classComponent = classNames('user-info', className);

    return (
      <div className={classComponent}>
        {name && (
          <UserPhoto
            name={name}
            pictureThumbId={pictureThumbId}
            pictureFileKey={pictureFileKey}
          />
        )}

        <div className="user-info-text">
          <span className="info--strong">{name}</span>
          {email && <span className="info--secondary">{email}</span>}
          {role && (
            <span className="info--secondary">
              <I18n label={role} />
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default UserInfo;
